<div class="company-event-modal-container">
  <span mat-dialog-title><mat-icon>event</mat-icon>Add New Event</span>
  <div mat-dialog-content>
    <form [formGroup]="companyEventForm">
      <div class="row align-top name">
        <mat-form-field>
          <mat-label>Event Name</mat-label>
          <input matInput type="text" formControlName="name" name="name"/>
        </mat-form-field>
      </div>
      <div class="row align-top type">
        <mat-form-field>
          <mat-label>Event Type</mat-label>
          <mat-select formControlName="type">
            @for (type of selectEventTypes; track type) {
              <mat-option [disabled]="selectEventTypes.length==0" [value]="type.id">{{type.name}}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <div class="row align-top">
        <div class="col-6 dates">
          <mat-form-field>
            <mat-label>Start Date</mat-label>
            <input matInput (dateChange)="onKeyUp($event)" [matDatepicker]="startPicker" formControlName="startDate" name="startDate">
            <mat-datepicker-toggle matIconPrefix [for]="startPicker"></mat-datepicker-toggle>
            <mat-datepicker #startPicker></mat-datepicker>
          </mat-form-field>
        </div>
        <div class="col-6 dates">
          <mat-form-field>
            <mat-label>End Date</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate" name="endDate"/>
            <mat-datepicker-toggle matIconPrefix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
      <div class="row align-top">
        <div class="col-md-6 time">
          <div class="row time-input">
            <mat-label>Start Time</mat-label>
            <input type="time" formControlName="startTime" name="startTime">
          </div>
        </div>
        <div class="col-md-6 time">
          <div class="row time-input">
            <mat-label>End Time</mat-label>
            <input type="time" formControlName="endTime" name="endTime">
          </div>
        </div>
      </div>
      @if (companyEventForm.controls['startDate'].value!==null && companyEventForm.controls['startTime'].value!==null) {
        <div class="row align-top">
          <mat-form-field>
            <mat-label>Timezone</mat-label>
            <mat-select formControlName="timezone">
              @for (tz of timezones; track tz) {
                <mat-option [disabled]="timezones.length==0" [value]="tz.tz">{{tz.abbr}}</mat-option>
              }
            </mat-select>
          </mat-form-field>
        </div>
      }
      <div class="row align-top sponsor-row">
        <div class="col-6 sponsor-title">
          <mat-label>CREA Sponsorship</mat-label>
        </div>
        <div class="col-6 sponsor-title">
          <mat-radio-group formControlName="is_sponsored">
            <mat-radio-button [value]=true>Yes</mat-radio-button>
            <mat-radio-button [checked]="true" [value]=false>No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      @if (companyEventForm.controls['is_sponsored'].value==true) {
        <div class="row align-top">
          <mat-form-field>
            <mat-label>Sponsorship Amount</mat-label>
            <input matInput formControlName="sponsorshipAmount" name="sponsorshipAmount" type="number"/>
            <span matTextPrefix>$&nbsp;</span>
          </mat-form-field>
        </div>
      }
      <div class="row align-top sponsor-row">
        <div class="col-6 sponsor-title">
          <mat-label>Co-sponsorship</mat-label>
        </div>
        <div class="col-6 sponsor-title">
          <mat-radio-group formControlName="is_cosponsored">
            <mat-radio-button [value]=true>Yes</mat-radio-button>
            <mat-radio-button [checked]="true" [value]=false>No</mat-radio-button>
          </mat-radio-group>
        </div>
      </div>
      @if (companyEventForm.controls['is_cosponsored'].value==true) {
        <div class="row align-top">
          <mat-form-field>
            <mat-label>Cosponsor Name</mat-label>
            <input matInput formControlName="cosponsor" name="cosponsor" type="text"/>
          </mat-form-field>
        </div>
      }
    </form>
  </div>
  <div mat-dialog-actions class="action-buttons">
    <button [disabled]="!validateFormFields() || isLoading" mat-button class="save" (click)="saveAndClose()">Save</button>
    <button [disabled]="!validateFormFields() || isLoading" mat-button class="addSave" (click)="saveAndAdd()">Save and Add Another</button>
    <button mat-button (click)="close()">Cancel</button>
  </div>
</div>
